var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEbbLocations(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Locations",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 40.59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #febc11;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m23.35,0C18.32,0,11.52,4.67,11.25,11.85c-.36,9.7,12.09,28.73,12.09,28.73,0,0,12.93-19.4,12.57-28.37C35.56,3.23,28.37,0,23.35,0Zm.24,21.03c-4.34,0-7.86-3.52-7.86-7.86s3.52-7.86,7.86-7.86,7.86,3.52,7.86,7.86-3.52,7.86-7.86,7.86Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEbbLocations);
export default __webpack_public_path__ + "static/media/ebb_locations.2b9b4ae78e0d263dd20c4d2e45a49c89.svg";
export { ForwardRef as ReactComponent };